import moment from 'moment';
import { DocumentsAPI } from 'api/document/document-core';
import { cache } from 'utils/cache';
import { CK_HOST, WS_CK_HOST } from './environment';

const tokenUrl = cache(
  DocumentsAPI.getCollaborationToken,
  moment.duration(30, 'minutes').asMilliseconds(),
);

export const cloudServices = {
  tokenUrl,
  uploadUrl: `https://${CK_HOST}/easyimage/upload/`,
  webSocketUrl: `${WS_CK_HOST}/ws`,
};
